import { Button } from 'antd';
import { env } from '../../env.ts';

const Fusion360Icon = () => {
	return (
		<svg
			width="1.25em"
			height="1.25em"
			viewBox="0 0 1667 1667"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			xmlSpace="preserve"
			focusable="false"
			aria-hidden="true"
			style={{
				display: 'inline-block',
				verticalAlign: '-0.25em',
				fillRule: 'evenodd',
				clipRule: 'evenodd',
				strokeLinejoin: 'round',
				strokeMiterlimit: 2,
			}}
		>
			<g transform="matrix(4.16667,0,0,4.16667,0,0)">
				<path
					d="M74,281.651C169.765,281.651 265.575,282.133 362.042,282.133C362.042,208.987 360.511,136.442 361.015,63.461C377.43,63.516 380.84,63.502 389.819,63.566C389.905,155.682 389.903,247.344 389.914,339.006C389.917,359.671 389.97,380.335 390,401C279.646,401 169.292,401 58.531,400.651C48.403,394.637 45.625,386.11 45.873,375.111C46.44,350.022 46.024,324.617 46.152,299.22C55.558,293.231 64.748,287.346 74,281.651Z"
					style={{ fill: 'rgb(148,61,1)', fillRule: 'nonzero' }}
				/>
				<path
					d="M74,1C165.688,1 257.375,1 349.231,1.283C349.85,2.02 350.225,2.614 350.764,2.909C358.873,7.353 362.431,14.059 362.179,23.396C361.823,36.543 362.124,49.708 362.093,63.339C362.042,136.4 362.042,208.987 362.042,282.133C265.575,282.133 169.809,282.133 74.021,281.652C73.999,189.452 73.999,97.715 74,5.986C74,4.324 74,2.662 74,1M244.5,64.061L176.276,64.061L176.276,219.647L215.021,219.647L215.021,156.711L265.611,156.711L265.611,128.981L215.086,128.981L215.086,92.107L274.85,92.107L274.85,64.061C264.793,64.061 255.146,64.061 244.5,64.061Z"
					style={{ fill: 'rgb(255,107,0)', fillRule: 'nonzero' }}
				/>
				<path
					d="M74.021,281.652C64.792,287.828 55.54,293.523 45.789,299.593C34.574,306.325 23.858,312.681 13.067,318.572C12.979,225.123 12.965,132.14 12.958,39.157C12.958,38.495 13.059,37.833 13.451,37.084C32.22,25.94 50.658,14.896 69.059,3.791C70.189,3.109 70.628,2.888 73.667,1C74.111,1 73.222,1 74,1C74.333,94.391 73.999,187.781 74.021,281.652Z"
					style={{ fill: 'rgb(255,149,72)', fillRule: 'nonzero' }}
				/>
				<g transform="matrix(1,0,0,1,-7.33839,-4.59052)">
					<path
						d="M163.398,328.378L150.8,328.378C151.191,322.682 153.282,318.108 157.075,314.658C160.867,311.207 165.416,309.482 170.722,309.482C176.549,309.482 181.505,311.133 185.59,314.434C189.676,317.736 191.718,321.712 191.718,326.363C191.718,331.437 189.212,336.023 184.199,340.121C187.389,342.141 189.724,344.25 191.205,346.449C192.687,348.648 193.427,351.279 193.427,354.341C193.427,360.172 191.49,364.847 187.617,368.365C183.743,371.883 178.616,373.642 172.236,373.642C166.311,373.642 161.404,371.957 157.514,368.588C153.624,365.219 151.223,360.54 150.312,354.55L163.203,354.55C164.733,360.475 167.678,363.437 172.04,363.437C174.221,363.437 176.061,362.662 177.558,361.111C179.055,359.561 179.804,357.643 179.804,355.358C179.804,352.551 178.901,350.257 177.094,348.478C175.288,346.699 172.968,345.81 170.136,345.81L167.841,345.81L167.841,335.312L169.208,335.312C172.171,335.312 174.547,334.582 176.337,333.121C178.128,331.661 179.023,329.73 179.023,327.329C179.023,325.154 178.315,323.296 176.899,321.755C175.483,320.213 173.749,319.443 171.699,319.443C166.914,319.443 164.147,322.421 163.398,328.378Z"
						style={{ fill: 'white', fillRule: 'nonzero' }}
					/>
					<path
						d="M222.187,310.556L238.583,310.556L223.185,331.552C225.303,331.162 227.225,330.966 228.953,330.966C234.33,330.966 238.966,332.968 242.86,336.972C246.754,340.976 248.701,345.745 248.701,351.279C248.701,357.724 246.406,363.063 241.816,367.294C237.226,371.526 231.415,373.642 224.384,373.642C217.874,373.642 212.495,371.567 208.247,367.416C203.998,363.266 201.874,357.984 201.874,351.572C201.874,346.949 202.932,342.213 205.048,337.363C207.164,332.512 209.508,328.281 212.08,324.667L222.187,310.556ZM234.492,351.205C234.492,348.399 233.594,346.041 231.799,344.132C230.004,342.223 227.801,341.269 225.191,341.269C222.351,341.269 219.953,342.24 217.995,344.181C216.037,346.123 215.058,348.497 215.058,351.303C215.058,354.077 216.029,356.419 217.971,358.327C219.912,360.236 222.319,361.191 225.191,361.191C227.736,361.191 229.923,360.212 231.75,358.254C233.578,356.296 234.492,353.946 234.492,351.205Z"
						style={{ fill: 'white', fillRule: 'nonzero' }}
					/>
					<path
						d="M278.583,309.677C285.973,309.677 291.865,312.509 296.259,318.173C300.654,323.837 302.851,331.406 302.851,340.878C302.851,351.946 300.41,360.157 295.527,365.512C290.644,370.867 284.996,373.544 278.583,373.544C271.259,373.544 265.327,370.688 260.786,364.975C256.245,359.262 253.974,351.751 253.974,342.441C253.974,332.545 256.196,324.61 260.639,318.637C265.082,312.664 270.934,309.677 278.193,309.677L278.583,309.677ZM289.765,342.05C289.765,335.735 288.756,330.771 286.738,327.158C284.719,323.544 282.001,321.738 278.583,321.738C275.003,321.738 272.187,323.544 270.136,327.158C268.085,330.771 267.06,335.8 267.06,342.245C267.06,348.105 268.102,352.792 270.185,356.308C272.268,359.824 275.003,361.581 278.388,361.581C281.839,361.581 284.597,359.824 286.664,356.308C288.732,352.792 289.765,348.04 289.765,342.05Z"
						style={{ fill: 'white', fillRule: 'nonzero' }}
					/>
				</g>
				<path
					d="M245,64.061L274.85,64.061L274.85,92.107L215.086,92.107L215.086,128.981L265.611,128.981L265.611,156.711L215.021,156.711L215.021,219.647L176.276,219.647L176.276,64.061C198.971,64.061 221.736,64.061 245,64.061Z"
					style={{ fill: 'rgb(255,254,253)', fillRule: 'nonzero' }}
				/>
			</g>
		</svg>
	);
};

interface ButtonProps {
	fusionURN: string;
}

const Fusion360Button = (props: ButtonProps) => {
	const hubUrl = env.VITE_AUTODESK_HUB_URL || 'https://partsbadger5.autodesk360.com';
	return (
		<Button
			// style={{
			// 	border: '1px solid rgb(255,149,72)',
			// 	background: 'rgb(255, 242, 233)',
			// }}
			icon={<Fusion360Icon />}
			href={`fusion360://lineageUrn=${encodeURIComponent(
				props.fusionURN
			)}&hubUrl=${encodeURIComponent(hubUrl)}`}
		>
			Open In Fusion
		</Button>
	);
};

export default Fusion360Button;
